import { render } from "./OrderBill.vue?vue&type=template&id=62d3950c"
import script from "./OrderBill.vue?vue&type=script&lang=js"
export * from "./OrderBill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__